// @core/api/endpoints/platform/enable_platform_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EnablePlatformProductRequest,
  PlatformProductResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Enable product on platform
 * Makes a product available on the platform. Tenants will be able to subscribe to this product. Optionally configure branding and default plans.
 */
export async function EnablePlatformProduct(
  platform_id: string,
  product_id: string,
  data: EnablePlatformProductRequest,
  options?: RequestOptions
): Promise<PlatformProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products/:product_id/enable`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<PlatformProductResponse>(requestPath, data, requestOptions);
}
